import { MORAL_PERSON_VALUE, PHYSICAL_PERSON_VALUE } from '../constants/constants';
import { formatDateForBackend } from './helper-functions';

export const getCatalogValuesForSelect = (catalog, key) => (
  catalog.map((item) => ({ value: item[key] }))
);

export const getCatalogValuesForRadio = (catalog, label, value) => (
  catalog.map((item) => ({ value: item[value], label: item[label] }))
);

export const makeValuesForm4 = (values) => {
  const store = {
    generalData: {},
    personalData: {},
    generalMoralData: {},
    representativePersonData: {},
    address: {},
    additionalData: {},
  };

  store.personType = values.personType;

  // General Data
  [
    'taxRegime',
    'name',
    'firstLastname',
    'secondLastname',
    'birthdate',
    'gender',
    'rfc',
  ].forEach((key) => {
    store.generalData[key] = values[key];
  });

  // Personal Data
  [
    'email',
    'cellphone',
    'maritalStatus',
    'occupation',
  ].forEach((key) => {
    store.personalData[key] = values[key];
  });

  // General Moral Data
  [
    'moralTaxRegime',
    'moralRfc',
    'socialReason',
  ].forEach((key) => {
    store.generalMoralData[key] = values[key];
  });

  // Representative Person Data
  [
    'representativeName',
    'representativeFirstLastname',
    'representativeSecondLastname',
    'representativeEmail',
    'representativeCellphone',
    'representativeBirthdate',
  ].forEach((key) => {
    store.representativePersonData[key] = values[key];
  });

  // Address
  [
    'postalCode',
    'state',
    'municipality',
    'colony',
    'street',
    'noExt',
    'noInt',
  ].forEach((key) => {
    store.address[key] = values[key];
  });

  // Additional Data
  [
    'activity',
    'sourceIncome',
    'nationality',
  ].forEach((key) => {
    store.additionalData[key] = values[key];
  });

  return store;
};

export const getContractingPersonData = (contracting, insured) => {
  if (contracting.data.samePerson !== 'no') {
    return {
      ...insured,
      data: {
        ...insured.data,
        samePerson: 'yes',
      },
    };
  }

  return contracting;
};

const getPersonPhone = (data) => {
  if (data.personType === PHYSICAL_PERSON_VALUE) {
    return data.personalData.cellphone;
  }
  return data.representativePersonData.representativeCellphone;
};

const getPersonRFC = (data) => {
  if (data.personType === PHYSICAL_PERSON_VALUE) {
    return data.generalData.rfc;
  }
  return data.generalMoralData.moralRfc;
};

const getPersonEmail = (data) => {
  if (data.personType === PHYSICAL_PERSON_VALUE) {
    return data.personalData.email;
  }
  return data.representativePersonData.representativeEmail;
};

const getPersonBirthdate = (data) => {
  if (data.personType === PHYSICAL_PERSON_VALUE) {
    return formatDateForBackend(data.generalData.birthdate);
  }
  return formatDateForBackend(data.representativePersonData.representativeBirthdate);
};

const getPhysicPersonData = (data) => {
  if (data.personType === PHYSICAL_PERSON_VALUE) {
    return {
      ocupationId: parseInt(data.personalData.occupation, 10),
      maritalStatus: parseInt(data.personalData.maritalStatus, 10),
      genderId: parseInt(data.generalData.gender, 10),
    };
  }
  return {};
};

const getPersonFullName = (data) => {
  const {
    generalData: { name, firstLastname, secondLastname },
  } = data;
  if (data.personType === PHYSICAL_PERSON_VALUE) {
    return { name, firstLastname, secondLastname };
  }
  return { name: data.generalMoralData.socialReason };
};

const getCustomerData = ({ data }) => {
  const {
    generalData: { name, firstLastname, secondLastname },
    representativePersonData: {
      representativeName: rName,
      representativeFirstLastname: rFirstLastname,
      representativeSecondLastname: rSecondLastname,
    },
  } = data;

  if (data.personType === PHYSICAL_PERSON_VALUE) {
    return {
      email: data.personalData.email,
      name: `${name} ${firstLastname} ${secondLastname}`,
      phone: data.personalData.cellphone,
    };
  }

  return {
    email: data.representativePersonData.representativeEmail,
    name: `${rName} ${rFirstLastname} ${rSecondLastname}`,
    phone: data.representativePersonData.representativeCellphone,
  };
};

const getTaxRegime = (data) => {
  const regime = {};
  regime.taxRegimeId = data.personType === PHYSICAL_PERSON_VALUE
    ? data.generalData.taxRegime
    : data.generalMoralData.moralTaxRegime;
  return regime.taxRegimeId ? regime : {};
};

const generateReference = (quoteId) => {
  const one = quoteId;
  const two = new Date().valueOf();
  const three = Math.floor(Math.random() * 1000);
  return `${one}-${two}-${three}`;
};

const getLegalRepresentative = (data) => {
  const {
    representativePersonData: {
      representativeName: rName,
      representativeFirstLastname: rFirstLastname,
      representativeSecondLastname: rSecondLastname,
    },
  } = data;
  if (data.personType === MORAL_PERSON_VALUE) {
    return {
      legalRepresentative: {
        name: rName,
        firstLastname: rFirstLastname,
        secondLastname: rSecondLastname,
      },
    };
  }
  return {};
};

const getPerson = (form) => {
  const { data } = form;
  return {
    typePerson: data.personType,
    ...getTaxRegime(data),
    ...getPersonFullName(data),
    ...getLegalRepresentative(data),
    ...getPhysicPersonData(data),
    email: getPersonEmail(data),
    birthdayDate: getPersonBirthdate(data),
    rfc: getPersonRFC(data),
    cellphone: getPersonPhone(data),
    zipCode: data.address.postalCode,
    entity: data.address.state,
    municipality: data.address.municipality,
    neighborhood: data.address.colony,
    street: data.address.street,
    ext: data.address.noExt,
    int: data.address.noInt,
    activityId: parseInt(data.additionalData.activity, 10),
    sourceIncome: data.additionalData.sourceIncome,
    nationalityId: parseInt(data.additionalData.nationality, 10),
    publicOffice: 'no', // Se coloca por defecto no
  };
};

const dataPayment = (forms) => ({
  card_number: forms.form7.cardNumber,
  holder_name: forms.form7.cardName,
  cvv: forms.form7.cardCVV,
  month: forms.form7.cardExpirationMonth,
  year: forms.form7.cardExpirationYear,
  provider: 'conekta', // Solo soporta conekta
  quote_id: forms.quoteId,
  recurrence: forms.form3.selectedPeriodicity.toUpperCase() === 'ANUAL' ? 0 : 1,
  customer: getCustomerData(forms.form5),
  reference: generateReference(forms.quoteId),
});

const dataPolicy = (forms) => ({
  quoteId: forms.quoteId,
  starting_at: (new Date()).toISOString().split('T')[0],
  isTheSameAsSecured: forms.form5.data.samePerson === 'yes' ? 'si' : 'no',
  secured: { ...getPerson(forms.form4), isOlderThan30: true },
  vehicle: {
    serial: forms.form6.serialNumber,
    motorNumber: forms.form6.engineNumber,
    numberPlate: forms.form6.plate,
    useVehicleId: forms.form6.useOfTheVehicle,
    serviceVehicleId: forms.form6.vehicleService,
    typeVehicleId: forms.form6.vehicleType,
    seating: 1, // Se coloca uno por defecto
    capacity: 1, // Se coloca 1 por defecto
  },
  payment: {
    paymentId: 1, // Poner por default 1
    number: '000000000000', // de donde se obtiene este valor, default 0
  },
  preferredBeneficiary: {
    preferredBeneficiaryId: forms.form7.preferredBeneficiary.id,
    name: forms.form7.preferredBeneficiary.name,
  },
  contractor: getPerson(forms.form5),
});

export const makeDataPaymentAndPolicy = (forms) => {
  return {
    policy: dataPolicy(forms),
    payment: dataPayment(forms),
  };
};
